import React, {FC, useEffect, useState} from "react";
import "../assets/styles/styles.scss";
import DataRequestIcon from "../assets/images/data_icon01.svg";
import DataMergeIcon from "../assets/images/data_icon02.svg";
import PublicDataIcon from "../assets/images/data_icon03.svg";
import ConsortiumIcon from "../assets/images/shine/icon01.svg";
import CatalogIcon from "../assets/images/shine/icon02.svg";
import PortalIcon from "../assets/images/shine/icon03.svg";
import DataSummary from "../components/DataSummary";
import BoardShortcut from "../components/BoardShortcut";
import MainBanner from "../components/MainBanner"
import {Link} from "react-router-dom";
import {useTypedSelector} from "../reducers";
import classNames from "classnames";
import ShineDataSummary from "../components/ShineDataSummary";
import mainVisual from "../assets/images/shine/main_visual.png";

interface MenuShortcutInterface {
    name: string;
    alt: string;
    image: string;
    route: string;
}

const MainPage: FC = () => {
    const {site} = useTypedSelector(state => state.profile);
    const [environment, setEnvironment] = useState("");

    const NcdcMenuShortcutData: MenuShortcutInterface[] = [
        {name: '데이터 신청', alt: '데이터 신청 아이콘', image: DataRequestIcon, route: '/request'},
        {name: '데이터 결합신청', alt: '데이터 결합신청', image: DataMergeIcon, route: '/request'},
        {name: '암공공데이터', alt: '암공공데이터', image: PublicDataIcon, route: '/request'},
    ];

    const ShineMenuShortcutData: MenuShortcutInterface[] = [
        {name: '컨소시움 소개', alt: '컨소시움 소개', image: ConsortiumIcon, route: '/static/5'},
        {name: '데이터 현황', alt: '데이터 현황', image: CatalogIcon, route: '/catalog'},
        {name: '데이터 제공 프로세스', alt: '데이터 제공 프로세스', image: PortalIcon, route: '/static/24'},
    ];

    const MenuShortcutData = site === 'ncdc' ? NcdcMenuShortcutData : ShineMenuShortcutData;

    useEffect(() => {
        if (navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('not-pc');   // 모바일(스마트폰+태블릿)일 때
        }
        // PC에서만 실행 될 스크립트   /*************** 테스트용 ***************/
        if (!navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)) {
            setEnvironment('pc');
            // setEnvironment('not-pc');
        }
    }, [environment]);

    const MenuShortcut: JSX.Element[] = MenuShortcutData.map(
        (ms: MenuShortcutInterface, idx: number) => {
            if(ms.name === '데이터 신청'){
                ms.route = environment === 'not-pc' ? '#' : '/request';
            }
            const onClickDataRequest = () => {
                if (environment === 'not-pc' && ms.name === '데이터 신청') {
                    alert('PC 환경에서 이용 바랍니다.');
                }
            }
            return (
                <Link to={ms.route} key={idx}>
                    <div className={classNames('menu-shortcut-item-wrapper', { 'middle': idx === 1 })} onClick={onClickDataRequest}>
                        <div className={'menu-shortcut-item'}>
                            <img src={ms.image} alt={ms.alt}/>
                            <span>{ms.name}</span>
                        </div>
                    </div>
                </Link>
            );
        });

    return (
        <div className={'main-page-wrapper'}>
            <div className={`main-visual-wrapper ${site}`}
                 style={{
                     backgroundImage: `url(${mainVisual})`
                     , backgroundSize: 'cover'
                     , backgroundPosition: 'center'
                     , backgroundRepeat: 'no-repeat'
                 }}>
                <div className={'main-visual-content'}>
                    {site === 'ncdc' ? <DataSummary/> : <ShineDataSummary />}
                </div>
            </div>
            <div className={`main-content-summary-wrapper wrapper flex-center ${site}`}>
                <div className={'main-content-summary content'}>
                    <div className={'menu-shortcut-wrapper'}>
                        {MenuShortcut}
                    </div>
                    <div className={'board-shortcut-wrapper'}>
                        <div className={'board-shortcut'}>
                            <BoardShortcut title={'공지사항'}/>
                            <BoardShortcut title={'FAQ'}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'main-banner-wrapper flex-center'}>
                <MainBanner/>
            </div>
        </div>
    )
}

export default MainPage;
